module.exports = __webpack_public_path__ + "img/V4.717dfc92.png";